import {ChangeDetectionStrategy, Component, Input, OnInit} from "@angular/core";
import {TaxReturnStatus} from "../model/status";
import {TaxReturnSnapshot} from "../../../../../swaggerServices";
import { TRANSLOCO_SCOPE } from '@jsverse/transloco';

interface ITaxReturnSnapshot extends TaxReturnSnapshot {
  createdAtStr?: string;
}

@Component({
    selector: 'app-snapshot-banner',
    templateUrl: './snapshot-banner.component.html',
    styleUrls: ['./snapshot-banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: TRANSLOCO_SCOPE,
            useValue: { scope: 'tax-returns', alias: 'taxReturns' },
        }
    ],
    standalone: false
})
export class SnapshotBannerComponent implements OnInit {
  @Input() status: TaxReturnStatus;
  @Input() snapshot: ITaxReturnSnapshot;

  constructor() { }

  ngOnInit() {
  }

}
